import styled from "styled-components";

export const GridContainer = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1.2fr 2fr 1fr 1fr;
  width: 100%;
  .left-position {
    justify-self: start;
  }
  .center-position {
    justify-self: center;
  }
  h3 {
    ${({ theme }) => `
      color: ${theme.colors.blackTextTitle};
    `}
    font-size: 1.4rem;
    font-weight: 500;
  }
  .complaint-status {
    display: flex;
    justify-self: center;
  }
`;

export const ComplaintContainer = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.white};
  `}
  align-items: center;
  border-radius: 1rem;
  display: flex;
  height: 56px;
  margin-top: 0.8rem;
  width: 100%;
`;

export const SubTitle = styled.span`
  ${({ theme }) => `
    color: ${theme.colors.gray};
  `}
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
`;

export const EmptyResult = styled.span`
  ${({ theme }) => `
    color: ${theme.colors.gray};
  `}
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0;
`;

export const DataContainer = styled.div`
  margin-bottom: 5rem;
`;

export const Footer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const AuxiliarContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ClearButton = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.white};
  `}
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  height: 50px;
  justify-content: center;
  width: 256px;
  h2 {
    font-size: 15px;
    font-weight: bold;
  }
`;
